export const documentsQueryKeyBySession = (sessionId: string | null) => ["documents", sessionId] as const;
